@if ((corporateTaxEntity$ | async)) {
  <form [formGroup]="investeringenFg">
    <div formArrayName="investeringen">
      @for (item of investeringen.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row mb-1">
          <div class="col-auto">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                            class="custom-input-150"
                                            formControlName="omschrijving"
                                            id="omschrijving-' + i"
            >
            </snelstart-ui-text-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control [label]="i === 0 ? 'Investeringsbedrag' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="totaleInvesteringInBoekjaar"
                                              id="bedrag-' + i"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Recht op KIA?' : ''"
                                              [options]="optionsJaNee"
                                              class="custom-input-150"
                                              formControlName="claimKia"
                                              id="claimKia-' + i"
            >
            </snelstart-ui-select-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Recht op EIA?' : ''"
                                              [disabledControl] = "item.get('claimMia')?.getRawValue() === true"
                                              [options]="optionsJaNee"
                                              class="custom-input-150"
                                              formControlName="claimEia"
                                              id="claimEia-' + i"
            >
            </snelstart-ui-select-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Recht op MIA?' : ''"
                                              [disabledControl] = "item.get('claimEia')?.getRawValue() === true"
                                              [options]="optionsJaNee"
                                              class="custom-input-150"
                                              formControlName="claimMia"
                                              id="claimMia-' + i"
            >
            </snelstart-ui-select-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-button (click)="showDialog(i); $event.preventDefault()"
                                 [class]="i === 0 ? 'firstrowbutton' : ''"
                                 icon="plus"
                                 type="secondary">Meer gegevens
            </snelstart-ui-button>
          </div>

          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i); $event.preventDefault()"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="1"
                       type="link">Investering toevoegen
  </snelstart-ui-button>
}


<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="Gegevens investering" size="lg"
                                title="Specificatie investering">
  <snelstart-ui-dialog-body>
    <form [formGroup]="investeringenFg">
      <div formArrayName="investeringen">
        <div *ngFor="let item of investeringen.controls; let i = index" [formGroupName]="i">
          <div *ngIf="i === this.index">
            <snelstart-ui-date-form-control (change)="saveForm()"
                                            class="custom-input-250"
                                            formControlName="datumIngebruikname"
                                            id="datumIngebruikname"
                                            label="Datum ingebruikname"
                                            placeholder="dd-mm-jjjj"
            >
            </snelstart-ui-date-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-250" formControlName="bedragBetaaldInBoekjaar"
                                              label="Betaald in boekjaar"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <div *ngIf="investeringen.controls[i].get('claimEia')?.getRawValue() === true">
              <snelstart-ui-number-form-control
                [showAllDecimals]="false"
                align="right"
                class="custom-input-250"
                formControlName="maximaleInvesteringBedragBedrijfsMiddel" label="Investeringsbedrag voor de EIA"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-text-form-control (change)="saveForm()"
                                              class="custom-input-250"
                                              formControlName="meldingsNummer"
                                              label="Meldingsnummer"
                                              placeholder="E012345678"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div *ngIf="investeringen.controls[i].get('claimMia')?.getRawValue() === true">
              <snelstart-ui-number-form-control
                (change)="saveForm()"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-250" formControlName="maximaleInvesteringBedragBedrijfsMiddel"
                label="Investeringsbedrag voor de MIA"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-select-form-control (change)="saveForm()"
                                                [options]="miaLetter"
                                                class="custom-input-250"
                                                formControlName="miaLetter"
                                                label="Meldingsletter MIA"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-text-form-control (change)="saveForm()"
                                              class="custom-input-250"
                                              formControlName="meldingsNummer"
                                              label="Meldingsnummer"
                                              placeholder="M012345678"
              >
              </snelstart-ui-text-form-control>
            </div>
          </div>
        </div>
      </div>
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check" id="save" type="primary">Akkoord</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

